export const PAGE_ANCHORS = {
  TOP_ANCHOR_ID: 'SCROLL_TO_TOP',
  TOP_ANCHOR_COMP_ID: 'PAGE_TOP_ANCHOR',
};
